import React, { PropsWithChildren, forwardRef } from 'react';
import { Group, Carousel, GroupProps, CarouselProps } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

const containerStyles = css({
    width: '100%',
    position: 'relative',
    display: 'block',
});

const carouselStyles = css({
    gap: {
        base: 'xl',
        md: 'sm',
        xxl: 'md',
    },
    mdDown: {
        '& > div:after': {
            zIndex: 'subOverlay',
            minWidth: 'xl',
        },
    },
});

export const Container = forwardRef<HTMLDivElement, GroupProps>(
    ({ children, ...props }, ref) => (
        <Group.Item ref={ref} className={containerStyles} {...props}>
            {children}
        </Group.Item>
    ),
);

export const GenericCarouselStyled: React.FC<
    PropsWithChildren<CarouselProps>
> = ({ children, ...props }) => (
    <Carousel className={carouselStyles} {...props}>
        {children}
    </Carousel>
);
